import { render, staticRenderFns } from "./ExportAlumniData.vue?vue&type=template&id=322f25ae&"
import script from "./ExportAlumniData.vue?vue&type=script&lang=js&"
export * from "./ExportAlumniData.vue?vue&type=script&lang=js&"
import style0 from "./ExportAlumniData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports